const Taskes = () => {
    return <h1>Taskes </h1>
};

export default Taskes; 